const PRODUCT_CACHE = new Map();

const FALLBACK_CATEGORIES = {
  footcare: [
    'fo-l-t', // エフゲン薬用フットオイル
    'f-deo-t', // エフゲンデオソープα
    'karu-light-t', // オリジナル軽石
    'tk-1-t', // アロマオイル入り軽石
    'ki-s', // 備長炭＆銅入り軽石
    'ay-t40-t', // 足ゆびちゃん40枚
    'ay-ld40-t', // 足ゆびちゃん レディース40枚
    'dsj-02-t', // 贅沢JUYAKU 6回分
  ],

  nailcare: [
    'nailoil-t', // フットネイルオイル
    'tumekiri', // 分厚い爪用爪切り
    'nail-file-13cm', // ネイルファイル13cm
    'nail-file-15cm', // ネイルファイル15cm
    'nipper', // ニッパー爪切り
  ],
};

const CROSS_SELL_RULES = {};

function registerRules(productIds, slots) {
  productIds.forEach((productId) => {
    CROSS_SELL_RULES[String(productId)] = slots;
  });
}

/*
  通常パッケージのエフゲン ＋ エフゲンリキッドα
  足ゆびちゃん40枚 ＋ デオソープα
*/
registerRules(
  [
    '7224123981888', // エフゲン 10mL
    '7224342380608', // エフゲン 30mL
    '7224342347840', // エフゲン 60mL
    '7224342413376', // エフゲン 250mL
    '7245740212288', // エフゲン 10mL 2本 初回限定
    '7245513359424', // エフゲン 30mL 2本
    '7245516308544', // エフゲン 60mL 2本
    '7245524467776', // エフゲン 30mL 3本
    '7245521420352', // エフゲン 250mL 2本
    '7245519781952', // エフゲンバリューセット
    '7242092478528', // エフゲンリキッドα
  ],
  [
    { primary: 'ay-t40-t', fallbackCategory: 'footcare' },
    { primary: 'f-deo-t', fallbackCategory: 'footcare' },
  ]
);

/*
  ピンクパッケージのエフゲン
  足ゆびちゃん レディース40枚 ＋ デオソープα
*/
registerRules(
  [
    '7245460963392', // エフゲン ピンク 10mL
    '7245464666176', // エフゲン ピンク 30mL
    '7247978856512', // エフゲン ピンク 10mL 2本 初回限定
    '7245512605760', // エフゲン ピンク 30mL 2本
    '7245523845184', // エフゲン ピンク 30mL 3本
    '7245522534464', // エフゲン ピンク スペシャルセット
  ],
  [
    { primary: 'ay-ld40-t', fallbackCategory: 'footcare' },
    { primary: 'f-deo-t', fallbackCategory: 'footcare' },
  ]
);

/*
  エフゲンクリームα
  オリジナル軽石 ＋ 贅沢JUYAKU 6回分
*/
registerRules(
  ['7242091298880'],
  [
    { primary: 'karu-light-t', fallbackCategory: 'footcare' },
    { primary: 'dsj-02-t', fallbackCategory: 'footcare' },
  ]
);

/*
  ネイルオイル
  フットケア ＋ ネイルオイル以外のネイルケア
*/
registerRules(
  ['7244259688512'],
  [
    { primary: 'fo-l-t', fallbackCategory: 'footcare' },
    { primary: 'nail-file-13cm', fallbackCategory: 'nailcare' },
  ]
);

/*
  爪切り
  ネイルオイル ＋ ネイルファイル13cm
*/
registerRules(
  [
    '7245693878336', // 分厚い爪用爪切り
    '7245696368704', // HARD HEAD ニッパー爪切り
  ],
  [
    { primary: 'nailoil-t', fallbackCategory: 'nailcare' },
    { primary: 'nail-file-13cm', fallbackCategory: 'nailcare' },
  ]
);

/*
  ネイルファイル2種
  爪切り ＋ ネイルオイル
*/
registerRules(
  [
    '7245696663616', // ネイルファイル13cm
    '7245697187904', // ネイルファイル15cm
  ],
  [
    { primary: 'tumekiri', fallbackCategory: 'nailcare' },
    { primary: 'nailoil-t', fallbackCategory: 'nailcare' },
  ]
);

/*
  フットケア商品
  爪切り ＋ ネイルケア
*/
registerRules(
  [
    '7244260966464', // フットオイル
    '7244260147264', // デオソープα
    '7245702856768', // 軽石
    '7245703544896', // 軽石2個セット
    '7245703970880', // 軽石3個セット
    '7245699940416', // アロマ軽石
    '7245700366400', // アロマ軽石2個セット
    '7245702332480', // アロマ軽石3個セット
    '7245699514432', // 備長炭＆銅入り軽石
    '7245698334784', // 銅入り軽石
    '7245830619200', // JUYAKU お試し2回分
    '7245830881344', // JUYAKU 6回分
    '7245831077952', // JUYAKU 10回分
    '7245825900608', // 足ゆびちゃん40枚
    '7245825933376', // 足ゆびちゃん100枚
    '7245826555968', // 足ゆびちゃん10枚
    '7245826785344', // 足ゆびちゃん80枚
    '7245827113024', // 足ゆびちゃん120枚
    '7245827211328', // 足ゆびちゃん レディース100枚
    '7245827407936', // 足ゆびちゃん レディース100枚 6箱
    '7245827801152', // 足ゆびちゃん レディース20枚
    '7245828063296', // 足ゆびちゃん レディース40枚
  ],
  [
    { primary: 'tumekiri', fallbackCategory: 'nailcare' },
    { primary: 'nailoil-t', fallbackCategory: 'nailcare' },
  ]
);

async function getProductByHandle(handle) {
  if (PRODUCT_CACHE.has(handle)) {
    return PRODUCT_CACHE.get(handle);
  }

  const request = fetch(`/products/${handle}.js`)
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .then((product) => {
      if (!product || !product.available) return null;
      return product;
    })
    .catch(() => null);

  PRODUCT_CACHE.set(handle, request);

  return request;
}

function getCartHandles(cart) {
  return new Set(
    (cart.items || [])
      .map((item) => {
        if (item.handle) return item.handle;

        const match = (item.url || '').match(/\/products\/([^/?]+)/);
        return match ? match[1] : null;
      })
      .filter(Boolean)
  );
}

async function getRecommendedProducts(productId) {
  const slots = CROSS_SELL_RULES[String(productId)];

  if (!slots) return [];

  /*
    カート情報と、指定商品の候補を同時に取得する。
    通常時は「カート → 商品1 → 商品2」の順番待ちをなくす。
  */
  const cartPromise = fetch('/cart.js')
    .then((response) => {
      if (!response.ok) return { items: [] };
      return response.json();
    })
    .catch(() => ({ items: [] }));

  const primaryProductRequests = slots.map((slot) =>
    getProductByHandle(slot.primary)
  );

  const [cart] = await Promise.all([
    cartPromise,
    ...primaryProductRequests,
  ]);

  const usedHandles = getCartHandles(cart);
  const recommendations = [];

  for (const slot of slots) {
    /*
      primary はすでに同時取得済みなので、
      在庫がある通常時はここで追加通信は発生しない。
    */
    const candidateHandles = [
      slot.primary,
      ...(FALLBACK_CATEGORIES[slot.fallbackCategory] || []),
    ];

    for (const handle of candidateHandles) {
      if (!handle || usedHandles.has(handle)) continue;

      const product = await getProductByHandle(handle);

      if (!product) continue;

      usedHandles.add(handle);
      recommendations.push(product);
      break;
    }
  }

  return recommendations;
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function renderRecommendations(container, products) {
  container.innerHTML = products
    .map((product) => {
      const imageSource =
        product.featured_image || (product.images && product.images[0]) || '';

      const imageUrl = imageSource.startsWith('//')
        ? `https:${imageSource}`
        : imageSource;

      const price = Math.round(product.price / 100).toLocaleString('ja-JP');
      const title = escapeHtml(product.title);
      const productUrl = product.url || `/products/${product.handle}`;

      return `
        <a
          href="${productUrl}"
          style="flex: 1; min-width: 0; text-decoration: none; color: inherit; text-align: center;"
        >
          ${
            imageUrl
              ? `<img
                  src="${imageUrl}"
                  alt="${title}"
                  style="width: 70%; aspect-ratio: 1; object-fit: cover; border-radius: 4px;"
                >`
              : ''
          }
          <p style="font-size: 0.75em; margin: 4px 0 2px; line-height: 1.3;">
            ${title}
          </p>
          <p style="font-size: 0.75em; margin: 0;">
            ¥${price}
          </p>
          <span style="font-size: 0.7em; text-decoration: underline;">
            詳細を見る
          </span>
        </a>
      `;
    })
    .join('');
}

if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    class CartNotification extends HTMLElement {
      constructor() {
        super();

        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener(
          'keyup',
          (event) => event.code === 'Escape' && this.close()
        );

        this.querySelectorAll('button[type="button"]').forEach(
          (closeButton) => {
            closeButton.addEventListener('click', this.close.bind(this));
          }
        );
      }

      open() {
        this.notification.classList.add('animate', 'active');

        this.notification.addEventListener(
          'transitionend',
          () => {
            this.notification.focus();
            trapFocus(this.notification);
          },
          { once: true }
        );

        document.body.addEventListener('click', this.onBodyClick);
      }

      close() {
        this.notification.classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus(this.activeElement);
      }

      async renderCrossSellRecommendations(parsedState) {
        const recommendationSection = document.getElementById(
          'cart-notification-recommendations'
        );

        const recommendationContainer = document.getElementById(
          'cart-notification-recs-inner'
        );

        if (!recommendationSection || !recommendationContainer) return;

        const products = await getRecommendedProducts(parsedState.product_id);

        if (!products.length) {
          recommendationContainer.innerHTML = '';
          recommendationSection.hidden = true;
          return;
        }

        recommendationSection.hidden = false;
        renderRecommendations(recommendationContainer, products);
      }

      renderContents(parsedState, addedQty = 1) {
        this.cartItemKey = parsedState.key;
        this.addedQuantity = addedQty || 1;

        this.getSectionsToRender().forEach((section) => {
          const target = document.getElementById(section.id);
          const html = parsedState.sections?.[section.id];

          if (!target || !html) return;

          target.innerHTML = this.getSectionInnerHTML(html, section.selector);
        });

        const quantityElement = this.querySelector('.added-quantity');

        if (quantityElement) {
          quantityElement.textContent = `${this.addedQuantity}個`;
        }

        if (this.header) this.header.reveal();

        this.renderCrossSellRecommendations(parsedState).catch(() => {
          const recommendationSection = document.getElementById(
            'cart-notification-recommendations'
          );

          const recommendationContainer = document.getElementById(
            'cart-notification-recs-inner'
          );

          if (recommendationContainer) {
            recommendationContainer.innerHTML = '';
          }

          if (recommendationSection) {
            recommendationSection.hidden = true;
          }
        });

        this.open();
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-notification-product',
            selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
          },
          {
            id: 'cart-notification-button',
          },
          {
            id: 'cart-icon-bubble',
          },
        ];
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      handleBodyClick(event) {
        const target = event.target;

        if (
          target !== this.notification &&
          !target.closest('cart-notification')
        ) {
          const disclosure = target.closest(
            'details-disclosure, header-menu'
          );

          this.activeElement = disclosure
            ? disclosure.querySelector('summary')
            : null;

          this.close();
        }
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    }
  );
}